// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import LanguagePicker from "./partials/language-picker";
import ModalMenu from "./partials/modal-menu";
import Counter from "./partials/counter";
import References from "./partials/references";
import Ctas from "./partials/ctas";
import HeaderMenu from "./partials/header-menu";
import TeammemberList from "./partials/teammember-list";
import Modal from "./partials/modal";
import MapPoints from "./partials/map-points";
import ProjectSlider from "./partials/project-slider";
import ReferencesList from "./partials/references-list";
import ProjectDetailModal from "./partials/project-detail-modal";
import BuyersForm from "./partials/buyers-form";
import CalculateWidth from "./partials/calculate-width";
import ModalMenuLanguage from "./partials/modal-menu-language";
import TextSlider from "./partials/text-slider";
import ProjectList from "./partials/project-list";
import SwiperPageHeader from "./partials/swiper-page-header";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    // $wrapper.querySelectorAll('[data-language-picker]').forEach( $el => (new LanguagePicker($el)));
    $wrapper.querySelectorAll('[data-modal-menu]').forEach( $el => (new ModalMenu($el)));
    $wrapper.querySelectorAll('[data-modal-menu-language]').forEach( $el => (new ModalMenuLanguage($el)));
    $wrapper.querySelectorAll('[data-count-up]').forEach( $el => (new Counter($el)));
    $wrapper.querySelectorAll('[data-header-menu]').forEach( $el => (new HeaderMenu($el)));

    $wrapper.querySelectorAll('[data-reference-slider]').forEach( $el => (new References($el)));
    $wrapper.querySelectorAll('[data-text-slider]').forEach( $el => (new TextSlider($el)));
    $wrapper.querySelectorAll('[data-cta-slider]').forEach( $el => (new Ctas($el)));
    $wrapper.querySelectorAll('[data-team-member-list]').forEach( $el => (new TeammemberList($el)));
    $wrapper.querySelectorAll('[data-references-list]').forEach( $el => (new ReferencesList($el)));
    $wrapper.querySelectorAll('[data-modal-container]').forEach( $el => (new Modal($el)));
    $wrapper.querySelectorAll('[data-block-type="block-google-map"]').forEach($el => (new MapPoints($el)));
    $wrapper.querySelectorAll('[data-projects-slider]').forEach($el => (new ProjectSlider($el)));
    $wrapper.querySelectorAll('[data-block-type="block-project-detail"]').forEach($el => (new ProjectDetailModal($el)));
    $wrapper.querySelectorAll('[data-block-type="block-form-buyers"]').forEach($el => (new BuyersForm($el)));
    $wrapper.querySelectorAll('[data-calculate-width]').forEach($el => (new CalculateWidth($el)));
    $wrapper.querySelectorAll('[data-block-type="block-projects-list"]').forEach($el => (new ProjectList($el)));
    $wrapper.querySelectorAll('[data-swiper-page-header]').forEach($el => (new SwiperPageHeader($el)));

    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);

    if ('history' in window) {
        window.history.scrollRestoration = 'manual';
    }
})();
